import {useMemo} from 'react'
import {StyleSheet, View} from 'react-native'
import {Trans} from '@lingui/react/macro'

import {useAgent, useSessionApi} from '#/state/session'
import {agentToSessionAccount} from '#/state/session/agent'
import {useLoggedOutViewControls} from '#/state/shell/logged-out'
import {atoms as a, useTheme} from '#/alf'
import {FormError} from '#/components/forms/FormError'
import {Text} from '#/components/Typography'
import {QrSessionBlock} from '../SignUpWizard/QrSessionBlock'
import {type QrSessionInitResult} from '../SignUpWizard/useQrSession'
import {FormContainer} from './FormContainer'

export function WidFlow({
  error,
  onPressBack,
  // onAttemptSuccess,
  initialData,
}: {
  error: string
  onPressBack: () => void
  // onAttemptSuccess: () => void
  /** Pre-loaded session data from requestDeleteAccount — skips the init request */
  initialData?: QrSessionInitResult
}) {
  const t = useTheme()
  const {logoutEveryAccount, removeAccount} = useSessionApi()
  const agent = useAgent()
  const {setShowLoggedOut} = useLoggedOutViewControls()
  const account = useMemo(() => agentToSessionAccount(agent), [agent])

  const onLogout = () => {
    if (account) removeAccount(account)
    logoutEveryAccount('Settings')
    setShowLoggedOut(true)
  }

  return (
    <FormContainer
      testID="loginForm"
      titleText={<Trans>Sign in</Trans>}
      style={{backgroundColor: 'transparent'}}>
      <View>
        <Text
          style={[
            a.text_sm,
            a.font_medium,
            t.atoms.text_contrast_medium,
            a.mb_sm,
            styles.labelText,
          ]}>
          <Trans>Remove user</Trans>
        </Text>
        <QrSessionBlock
          size={300}
          queryKey="remove-user"
          initFn={(signal, prevServiceId, prevSessionId) =>
            agent.account.requestDeleteAccount(
              {
                ...(prevServiceId && {serviceId: prevServiceId}),
                ...(prevSessionId && {sessionId: prevSessionId}),
              },
              {signal},
            )
          }
          initialData={initialData}
          statusFn={(params, signal) =>
            agent.quicklogin.status(params, {signal})
          }
          onCompleted={data => {
            if (!data.approvalToken) return
            void agent.account
              .deleteAccount({approvalToken: data.approvalToken})
              .then(onLogout)
              .catch(() => {})
          }}
          autoRefresh
        />
      </View>
      <FormError error={error} />
      <View style={[a.flex_row, a.align_center, a.pt_md, a.self_center]}>
        <button className={'BackButton'} onClick={onPressBack}>
          <Trans>Back</Trans>
        </button>
        <View style={a.flex_1} />
      </View>
    </FormContainer>
  )
}

const styles = StyleSheet.create({
  labelText: {
    textAlign: 'center',
    fontSize: 16,
  },
})
